import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { makeStyles, tokens } from '@fluentui/react-components';

const { ZIndexShellComponents } = Constants;

export const useAppLayoutStyles = makeStyles({
  topBannerNew: {
    backgroundColor: tokens.colorNeutralBackground5,
    gridColumn: '1 / span 5 !important',
  },
  copilotNew: {
    gridRow: '3 / span 3 !important',
    backgroundColor: tokens.colorNeutralBackground5,
  },
  copilotNewPadding: {
    paddingLeft: tokens.spacingHorizontalS,
  },
  tabNewScopePanelExpanded: {
    backgroundColor: tokens.colorNeutralBackground2,
  },
  tabNewScopePanelCollapsed: {
    backgroundColor: tokens.colorNeutralBackground5,
  },
  statusNew: {
    backgroundColor: tokens.colorNeutralBackground5,
  },
  statusExtended: {
    gridColumn: '4 !important',
    gridRow: '3 !important',
  },
  menuExtended: {
    gridRow: '3 / span 3 !important',
  },
});

export const useContainerStyles = makeStyles({
  container: {
    display: 'grid',
    gridTemplateColumns: 'auto auto auto 1fr',
    gridTemplateRows: 'auto auto auto auto minmax(0px, 1fr)',
    height: '100vh',

    '& .app-shell-header': {
      gridColumn: '1 / span 5',
      gridRow: 1,
      position: 'relative',
      zIndex: ZIndexShellComponents.Header,
    },
    '& .app-shell-topBanner': {
      gridColumn: '1 / span 4',
      gridRow: 2,
      zIndex: ZIndexShellComponents.TopBanner,
      position: 'relative',
    },
    '& .app-shell-nav': {
      gridColumn: 1,
      gridRow: '3 / span 3',
      position: 'relative',
      display: 'flex',
    },
    '& .app-shell-status': {
      gridColumn: '3 / span 2',
      gridRow: 3,
      position: 'relative',
      zIndex: ZIndexShellComponents.Status,
    },
    '& .app-shell-scopePanel': {
      gridColumn: '2',
      gridRow: '3 / span 3',
      position: 'relative',
    },
    '& .app-shell-messageBar': {
      gridColumn: '3 / span 2',
      gridRow: '4',
      position: 'relative',
      zIndex: ZIndexShellComponents.MessageBar,
    },
    '& .app-shell-menu': {
      gridColumn: '3',
      gridRow: 5,
      position: 'relative',
      display: 'flex',
    },
    '& main': {
      gridColumn: '4',
      gridRow: 5,
      display: 'grid',
      gridTemplateColumns: 'minmax(0px, 1fr)',
      gridTemplateRows: 'auto auto 1fr',
      '& .app-shell-tab': {
        gridRow: 1,
        position: 'relative',
        zIndex: ZIndexShellComponents.Tab,
      },
      '& .app-shell-subTab': {
        gridRow: 2,
        position: 'relative',
        zIndex: ZIndexShellComponents.SubTab,
      },
      '& .app-shell-content': {
        gridRow: 3,
        overflow: 'hidden',
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        zIndex: ZIndexShellComponents.Content,
      },
    },
    '& .app-shell-copilot': {
      gridColumn: '5',
      gridRow: '2 / span 4',
      display: 'flex',
    },
    '& .app-shell-overlay': {
      gridColumn: '1 / span 4',
      gridRow: '2 / span 4',
      position: 'relative',
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      zIndex: ZIndexShellComponents.Panel,
    },
  },
});
